
<v-dialog
    v-model       = "show"
    :max-width    = "400"
    persistent
    hide-overlay
    content-class = "dialog-border"
>
    <div class="white preview-panel">
        <div class="close-button">
            <c-toolbar-button
                size     = "28"
                color    = "red"
                icon     = "mdi-close"
                :tooltip = "$t('common.cancel')"
                @click   = "onCancel"
            />
        </div>

        <img
            v-if  = "image"
            :src  = "image"
            alt   = ""
            class = "preview-image"
        />
    </div>
</v-dialog>
